import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";
import { AWARD_CODES } from "../../common/enums/award-codes";
import { VisionBonusOverviewResponse } from "./VisionBonusAPI.types";

type VisionBonusRequestParams = {
  AffAbo: string;
  Locale: string;
  Period: string;
  CountryCode: string;
  IsoCurrencyCode: string;
  StartFromPY?: string;
};

export const visionBonusAPI = createApi({
  reducerPath: "visionBonusAPI",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getVisionBonusOverview: builder.query<VisionBonusOverviewResponse, VisionBonusRequestParams>({
      query: (params) => {
        const { AffAbo, Locale, Period, CountryCode, IsoCurrencyCode, StartFromPY } = params;
        const queryParams = new URLSearchParams({
          AffAbo: AffAbo,
          Locale: Locale,
          Period: Period,
          CountryCode: CountryCode,
          IsoCurrencyCode: IsoCurrencyCode,
        });

        if (StartFromPY) {
          queryParams.append("StartFromPY", `${StartFromPY}`);
        }

        return `/incentives-v2/api/visionbonus/overview?${queryParams}`;
      },
    }),
  }),
});

export const { useGetVisionBonusOverviewQuery } = visionBonusAPI;
